import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

export default function LegalMentions() {
  return (
    <div className="relative min-h-screen pt-20 text-black overflow-hidden bg-white">
      <NavBar />

      <section className="px-6 pt-10 pb-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-semibold leading-tight">Mentions Légales</h1>
          <p className="mt-3 text-sm text-gray-500">En vigueur au 10/08/2025</p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="max-w-3xl mx-auto space-y-10 text-[15px] leading-7 text-gray-800">

          <p>
            Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'économie
            numérique (LCEN), il est porté à la connaissance des utilisateurs et visiteurs du site{" "}
            <span className="font-medium">noxzi.fr</span> (ci-après « le Site ») les présentes mentions légales.
          </p>
          <p>
            La connexion et la navigation sur le Site valent acceptation sans réserve des présentes mentions légales,
            accessibles en permanence via le lien en bas de page.
          </p>

          {/* 1. Éditeur */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">1. Éditeur du site</h2>
            <p>Le Site est édité par :</p>
            <ul className="mt-3 space-y-1 pl-0 list-none">
              <li><span className="font-medium">Dénomination sociale :</span> NOXZI</li>
              <li><span className="font-medium">Forme juridique :</span> Société par actions simplifiée unipersonnelle (SASU)</li>
              <li><span className="font-medium">Capital social :</span> 100,00 €</li>
              <li><span className="font-medium">Siège social :</span> 792 Chemin de Charrière Neuve, 73000 Chambéry, France</li>
              <li><span className="font-medium">RCS :</span> Chambéry — SIREN 990 027 377</li>
              <li><span className="font-medium">Numéro de TVA intracommunautaire :</span> (non encore attribué / à compléter)</li>
              <li><span className="font-medium">Téléphone :</span> +33 (0)6 03 59 99 52</li>
              <li>
                <span className="font-medium">E-mail :</span>{" "}
                <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>
              </li>
              <li><span className="font-medium">Directeur de la publication :</span> Lionel FAURE</li>
            </ul>
          </section>

          {/* 2. Hébergeur */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">2. Hébergeur</h2>
            <p>Le Site est hébergé par :</p>
            <ul className="mt-3 space-y-1 list-none pl-0">
              <li><span className="font-medium">Raison sociale :</span> LWS – Ligne Web Services</li>
              <li><span className="font-medium">Siège social :</span> 4 rue Galvani, 75017 Paris, France</li>
              <li><span className="font-medium">Téléphone :</span> +33 1 77 62 30 03</li>
              <li>
                <span className="font-medium">Site :</span>{" "}
                <a href="https://www.lws.fr" target="_blank" rel="noreferrer" className="underline">
                  www.lws.fr
                </a>
              </li>
            </ul>
          </section>

          {/* 3. Accès au site */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">3. Accès au site</h2>
            <p>
              Le Site est en principe accessible 24h/24 et 7j/7, sauf interruption programmée ou non, notamment pour
              des besoins de maintenance ou en cas de force majeure. En cas d'impossibilité d'accès au Site, NOXZI
              s'engage à faire ses meilleurs efforts pour en rétablir l'accès dans les meilleurs délais. Le Site ne
              saurait être tenu responsable de tout dommage, quelle qu'en soit la nature, résultant d'une indisponibilité.
            </p>
          </section>

          {/* 4. Propriété intellectuelle */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">4. Propriété intellectuelle</h2>
            <p>
              L'ensemble des éléments constituant le Site (structure, textes, images, photographies, logos, marques,
              icônes, sons, logiciels, etc.) est la propriété exclusive de NOXZI ou de ses partenaires, et est protégé
              par les lois françaises et internationales relatives à la propriété intellectuelle.
            </p>
            <p className="mt-3">
              Toute reproduction, représentation, modification, publication, adaptation ou exploitation de tout ou
              partie du contenu du Site, par quelque procédé que ce soit, sans l'autorisation préalable et écrite de
              NOXZI, est strictement interdite et constituerait une contrefaçon sanctionnée par les articles L. 335-2
              et suivants du Code de la propriété intellectuelle.
            </p>
            <p className="mt-3">
              La marque <span className="font-medium">NOXZI</span> et les logos figurant sur le Site sont des marques
              déposées ou en cours de dépôt. Toute utilisation sans autorisation préalable et écrite est strictement
              prohibée.
            </p>
          </section>

          {/* 5. Responsabilité */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">5. Limitation de responsabilité</h2>
            <p>
              NOXZI s'efforce de fournir sur le Site des informations aussi précises que possible. Toutefois, elle ne
              pourra être tenue responsable des omissions, inexactitudes ou carences dans la mise à jour des
              informations publiées, qu'elles soient de son fait ou du fait des tiers qui lui fournissent ces
              informations.
            </p>
            <p className="mt-3">
              Les informations diffusées sur le Site sont présentées à titre purement indicatif et ne sauraient
              constituer un conseil juridique, fiscal ou commercial. NOXZI ne pourra être tenue responsable de
              l'utilisation qui en est faite.
            </p>
            <p className="mt-3">
              NOXZI ne pourra être tenue responsable des dommages directs et indirects causés au matériel de
              l'utilisateur lors de l'accès au Site, résultant notamment de l'utilisation d'un matériel ne répondant
              pas aux spécifications indiquées, de l'apparition d'un bug ou d'une incompatibilité.
            </p>
          </section>

          {/* 6. Liens hypertextes */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">6. Liens hypertextes</h2>
            <p>
              Le Site peut contenir des liens hypertextes vers d'autres sites internet ou ressources en ligne. NOXZI
              ne dispose d'aucun moyen de contrôle sur ces sites tiers et n'assume aucune responsabilité quant à leur
              contenu, publicités, produits ou services disponibles sur ou à partir de ces sites.
            </p>
            <p className="mt-3">
              La mise en place d'un lien hypertexte vers le Site est autorisée à condition qu'elle ne porte pas
              atteinte à l'image de NOXZI et qu'elle n'induise pas en erreur l'utilisateur quant à l'origine du
              contenu. Tout lien en frame (cadre) est expressément interdit sans accord préalable et écrit de NOXZI.
            </p>
          </section>

          {/* 7. Cookies */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">7. Cookies</h2>
            <p>
              Lors de la navigation sur le Site, des cookies peuvent être déposés sur le terminal de l'utilisateur.
              Un cookie est un petit fichier texte enregistré par le navigateur permettant d'analyser la navigation
              ou de mémoriser des préférences.
            </p>
            <p className="mt-3">
              Conformément à la loi n° 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux
              libertés (Loi Informatique et Libertés) et aux recommandations de la CNIL, l'utilisateur peut s'opposer
              à l'enregistrement de cookies en configurant son navigateur.
            </p>
            <p className="mt-3">
              Pour plus d'informations, veuillez consulter nos{" "}
              <Link to="/cgu" className="underline">Conditions Générales d'Utilisation</Link>.
            </p>
          </section>

          {/* 8. Données personnelles */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">8. Protection des données personnelles (RGPD)</h2>
            <p>
              NOXZI traite des données à caractère personnel dans le respect du Règlement (UE) 2016/679 du 27 avril
              2016 relatif à la protection des personnes physiques à l'égard du traitement des données à caractère
              personnel (RGPD) et de la loi Informatique et Libertés du 6 janvier 1978 modifiée.
            </p>
            <p className="mt-3">Les données collectées via les formulaires du Site sont utilisées aux fins suivantes :</p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Traitement et suivi des demandes de contact et de devis ;</li>
              <li>Gestion de la relation commerciale et suivi des prestations ;</li>
              <li>Envoi de communications commerciales (avec consentement préalable).</li>
            </ul>
            <p className="mt-3">
              Conformément à la réglementation en vigueur, vous disposez des droits suivants sur vos données :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Droit d'accès (art. 15 RGPD) ;</li>
              <li>Droit de rectification (art. 16 RGPD) ;</li>
              <li>Droit à l'effacement (art. 17 RGPD) ;</li>
              <li>Droit à la limitation du traitement (art. 18 RGPD) ;</li>
              <li>Droit à la portabilité (art. 20 RGPD) ;</li>
              <li>Droit d'opposition (art. 21 RGPD).</li>
            </ul>
            <p className="mt-3">
              Pour exercer ces droits ou pour toute question relative au traitement de vos données, vous pouvez
              contacter NOXZI à l'adresse suivante :{" "}
              <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>.
            </p>
            <p className="mt-3">
              En cas de réponse insatisfaisante, vous disposez du droit d'introduire une réclamation auprès de la
              Commission Nationale de l'Informatique et des Libertés (CNIL) — 3 Place de Fontenoy, 75007 Paris —{" "}
              <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="underline">www.cnil.fr</a>.
            </p>
            <p className="mt-3">
              Pour en savoir plus, consultez notre{" "}
              <Link to="/politique-de-confidentialite" className="underline">Politique de confidentialité</Link>.
            </p>
          </section>

          {/* 9. Droit applicable */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">9. Droit applicable et juridiction compétente</h2>
            <p>
              Les présentes mentions légales sont régies par le droit français. En cas de litige, et après toute
              tentative de résolution amiable, les tribunaux français seront seuls compétents. Pour les litiges de
              consommation, le consommateur peut recourir à la médiation conventionnelle ou à tout autre mode
              alternatif de règlement des différends.
            </p>
          </section>

          {/* 10. Mise à jour */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">10. Mise à jour des mentions légales</h2>
            <p>
              NOXZI se réserve le droit de modifier les présentes mentions légales à tout moment, notamment pour se
              conformer à toute nouvelle réglementation en vigueur. L'utilisateur est invité à les consulter
              régulièrement. Les modifications prennent effet dès leur mise en ligne.
            </p>
          </section>

        </div>
      </section>

      <Footer />
    </div>
  );
}